import { config } from "@/configs/config";

interface IAuthNavItem {
  name: string;
  href?: {
    ge: string;
    uz: string;
    uk: string;
  };
  isDropdown?: boolean;
  children?: {
    name: string;
    href: Record<string, string>;
  }[];
}

const BASE_URLS = {
  ge: config.external_boxette_ge,
  uz: config.external_boxette_uz,
  uk: config.external_boxette_uk,
};

const UKRAINIAN_EXTERNAL_LANGUAGE_PREFIXES = new Set(["uk", "en"]);

export const authNavitems: IAuthNavItem[] = [
  {
    name: "services",
    children: [
      {
        name: "buy_for_me",
        href: {
          uz: "/services/usluga-kupim-za-vas",
          ge: null,
          uk: null,
        },
      },
      {
        name: "buy_myself",
        href: {
          uz: "/pokupayu-sam",
          ge: null,
          uk: null,
        },
      },
      {
        name: "shipping_from_usa",
        href: {
          ge: "/services/amanatebi-amerikidan",
          uz: "/services/dostavka-iz-ssha",
          uk: null,
        },
      },
      {
        name: "shipping_from_turkey",
        href: {
          ge: null,
          uz: "/services/dostavka-iz-turcii",
          uk: null,
        },
      },
      {
        name: "shipping_from_china_avia",
        href: {
          ge: "/services/amanatebi-chinetidan-avia",
          uz: null,
          uk: null,
        },
      },
      {
        name: "shipping_from_georgia",
        href: {
          ge: "/services/amanatebis-gzavnilebi-sakartvelodan-mteli-msoplios-mimartulebit",
          uz: null,
          uk: null,
        },
      },
      {
        name: "shipping_from_greece",
        href: {
          ge: "/services/amanatebi-saberdznetidan",
          uz: null,
          uk: null,
        },
      },
      {
        name: "shipping_from_china_land",
        href: {
          ge: "/services/amanatebi-chinetidan-sakhmeleto",
          uz: null,
          uk: null,
        },
      },
      // Ukraine-specific service
      {
        name: "address_in_usa",
        href: {
          uk: "/nashi-uslugi",
          uz: null,
          ge: null,
        },
      },
      {
        name: "delivery_from_china",
        href: {
          uk: "/dostavka-iz-kitaya",
          uz: null,
          ge: null,
        },
      },
      {
        name: "personal_parcels_from_usa",
        href: {
          uk: "/posilki-v-ukrainu",
          uz: null,
          ge: null,
        },
      },
      {
        name: "redemption_of_goods",
        href: {
          uk: "/vikup-tovarov",
          uz: null,
          ge: null,
        },
      },
      {
        name: "economical_delivery_service",
        href: {
          uk: "/ekonom-dostavka",
          uz: null,
          ge: null,
        },
      },
      {
        name: "express_sea_shipping",
        href: {
          uk: "/dostavka-morem",
          uz: null,
          ge: null,
        },
      },
      {
        name: "spare_parts_delivery",
        href: {
          uk: "/vikup-zapchastey",
          uz: null,
          ge: null,
        },
      },
    ],
    isDropdown: true,
  },
  {
    name: "rates",
    href: {
      ge: "/tariffs",
      uz: "/tariffs",
      uk: "/costs",
    },
  },
  {
    name: "about_us",
    href: {
      ge: "/about",
      uz: "/about",
      uk: "/kompaniya",
    },
  },
  {
    name: "how_we_work",
    href: {
      ge: null,
      uz: "/kak-my-rabotaem",
      uk: null,
    },
  },
  {
    name: "track_your_order",
    href: {
      ge: "/#track-block",
      uz: null,
      uk: null,
    },
  },
  {
    name: "where_to_buy",
    href: {
      ge: "/shops",
      uz: "/shops",
      uk: "/#sales-and-discount",
    },
  },
  {
    name: "university_of_shopping",
    href: {
      ge: "/blog",
      uz: "/blog",
      uk: "/blog",
    },
  },
  {
    name: "contacts",
    href: {
      ge: "/contacts",
      uz: "/contacts",
      uk: "/kontakty",
    },
  },
  {
    name: "faq",
    href: {
      ge: "/faq",
      uz: "/faq",
      uk: "/faq",
    },
  },
];

export const getCountrySpecificUrl = (
  countryCode: keyof typeof BASE_URLS,
  path: string,
  locale?: string,
) => {
  if (path.startsWith("http")) {
    return path;
  }

  const normalizedPath =
    countryCode === "uk" ? getUkrainianLocalizedPath(path, locale) : path;

  const baseUrl = BASE_URLS[countryCode];
  return baseUrl ? `${baseUrl}${normalizedPath}` : normalizedPath;
};

const getUkrainianLocalizedPath = (path: string, locale?: string) => {
  if (!locale || !UKRAINIAN_EXTERNAL_LANGUAGE_PREFIXES.has(locale)) {
    return path;
  }

  const localePrefix = `/${locale}`;

  if (path === localePrefix || path.startsWith(`${localePrefix}/`)) {
    return path;
  }

  return `${localePrefix}${path}`;
};
